module.exports = __webpack_public_path__ + "images/imageBackground2.bf847280.png";